import React, { Component, Fragment } from "react";

export default class Footer extends Component {

    constructor(props) {
        super(props);

        this.state = {
            aplicationName: "Percentual"
        }
    }

    render() {
        return (
            <Fragment>
                <p>
                    <strong>H/A com Percentual de Evasão (-10%):</strong> <span style={{ fontSize: "20px" }}>{(this.props.total * 0.90).toLocaleString("pt-BR", { maximumFractionDigits: 0 , style: 'decimal' })}</span>
                </p>
            </Fragment>
        )
    }
}



